import React, { useRef, useState } from "react";
import { useModal } from "hooks";
import locale from "localization";
import styles from "./user-attribute-edit.module.scss";
import { FormMode } from "enums";
import { Path } from "enums";
import { Intro, BackLink } from "components/commons";
import UserAttributeDetailsModule from "../user-attribute-details/user-attribute-details.module";
import { useHistory } from "react-router-dom";

const EditUserAttributeModule = (props) => {
  const userAttributeRef = useRef();
  const [updateLoading, setUpdateLoading] = useState(false);
  const [disableUpdate, setDisableUpdate] = useState(false);
  const attributeId = props.location.state ? props.location.state.attributeId : "";
  const history = useHistory();
  const successModal = useModal();

  return (
    <div>
      <BackLink text={locale.userAttributes} path={Path.Attributes} />
      <div className={styles.intro}>
        <Intro
          title={locale.editUserAttribute}
          titleStyle={styles.title}
          actionClassName={styles.primarySaveButton}
          actionLoading={updateLoading}
          actionDisabled={disableUpdate}
          actionText={locale.save}
          actionOnClick={() => {
            userAttributeRef.current.handleUpdate();
          }}
          actionSecondaryText={locale.cancel}
          actionSecondaryOutlined
          actionSecondaryOnClick={() => {
            history.goBack();
          }}
          actionSecondaryClassName={styles.secondarySaveButton}
        />
        <UserAttributeDetailsModule
          pageMode={FormMode.Edit}
          {...successModal}
          attributeId={attributeId}
          setUpdateLoading={setUpdateLoading}
          setDisableUpdate={setDisableUpdate}
          ref={userAttributeRef}
        />
      </div>
    </div>
  );
};

export default EditUserAttributeModule;
